import { MagicConfigMixin, formatDate } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var UploadStatus;
(function(UploadStatus2) {
  UploadStatus2["NORMAL"] = "normal";
  UploadStatus2["FAILED"] = "failed";
  UploadStatus2["PENDING"] = "pending";
  UploadStatus2["VERIFIED"] = "verified";
  UploadStatus2["REJECTED"] = "rejected";
})(UploadStatus || (UploadStatus = {}));
const amlToUploadStatus = {
  [AmlStatus.NOT_SET]: UploadStatus.NORMAL,
  [AmlStatus.PENDING]: UploadStatus.NORMAL,
  [AmlStatus.PROCESSING]: UploadStatus.PENDING,
  [AmlStatus.REQUESTED]: UploadStatus.NORMAL,
  [AmlStatus.USER_REQUESTED]: UploadStatus.NORMAL,
  [AmlStatus.REJECTED]: UploadStatus.REJECTED,
  [AmlStatus.APPROVED]: UploadStatus.VERIFIED,
  [AmlStatus.PENDING_REQUEST]: UploadStatus.NORMAL
};
const documentRequestStatuses = [AmlStatus.REQUESTED, AmlStatus.USER_REQUESTED];
let FileUploadComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.files = [];
    this.supportedFileTypes = [
      "image/bmp",
      "image/png",
      "image/gif",
      "image/jpeg",
      "application/pdf"
    ];
    this.UploadStatus = UploadStatus;
  }
  get uploadedFiles() {
    return this.previousFiles.filter((file) => !documentRequestStatuses.includes(file.statusText));
  }
  get hasPendingUpload() {
    return this.files.some(({ progress }) => progress < 100);
  }
  fileChosen() {
    const fileInput = this.$refs.fileInput;
    for (const file of Array.from(fileInput.files)) {
      this.addFile(file);
    }
  }
  fileDropped(event) {
    if (!event.dataTransfer) {
      return;
    }
    if (event.dataTransfer.items) {
      const eventFiles = Array.from(event.dataTransfer.items);
      for (const file of eventFiles) {
        if (file.kind === "file") {
          this.addFile(file.getAsFile());
        }
      }
    } else {
      const eventFiles = Array.from(event.dataTransfer.files);
      for (const file of eventFiles) {
        this.addFile(file);
      }
    }
  }
  addFile(file) {
    if (!this.supportedFileTypes.includes(file.type)) {
      this.uploadError(this.$t("file-upload.unsupported-type", {
        file: file.name
      }));
      return;
    }
    const fileStatus = {
      file,
      progress: 0,
      hasError: false
    };
    this.files.push(fileStatus);
    return {
      file,
      onProgressChange: (progress, hasError) => {
        if (hasError) {
          fileStatus.hasError = true;
          return;
        }
        fileStatus.progress = Math.round(progress * 100);
      }
    };
  }
  uploadError(message) {
    return message;
  }
  isNormal(status) {
    return amlToUploadStatus[status] === UploadStatus.NORMAL;
  }
  isFailed(status) {
    return amlToUploadStatus[status] === UploadStatus.FAILED;
  }
  isPending(status) {
    return amlToUploadStatus[status] === UploadStatus.PENDING;
  }
  isVerified(status) {
    return amlToUploadStatus[status] === UploadStatus.VERIFIED;
  }
  isRejected(status) {
    return amlToUploadStatus[status] === UploadStatus.REJECTED;
  }
  getStatusTranslation(status) {
    switch (amlToUploadStatus[status]) {
      case UploadStatus.FAILED:
        return "file-upload.failed";
      case UploadStatus.REJECTED:
        return "file-upload.error";
      case UploadStatus.VERIFIED:
        return "file-upload.verified";
      default:
        return "file-upload.pending";
    }
  }
  getStatusIcon(status) {
    switch (amlToUploadStatus[status]) {
      case UploadStatus.FAILED:
      case UploadStatus.REJECTED:
        return "file-upload";
      case UploadStatus.PENDING:
        return "timestamp";
      case UploadStatus.VERIFIED:
        return "checked";
      default:
        return "";
    }
  }
  getStatusIconClass(status) {
    switch (amlToUploadStatus[status]) {
      case UploadStatus.FAILED:
      case UploadStatus.REJECTED:
        return "icon--file-rejected";
      case UploadStatus.NORMAL:
      case UploadStatus.PENDING:
        return "icon--file-pending";
      case UploadStatus.VERIFIED:
        return "icon--file-verified";
      default:
        return "";
    }
  }
};
__decorateClass([
  Prop(String)
], FileUploadComponent.prototype, "header", 2);
__decorateClass([
  Prop(String)
], FileUploadComponent.prototype, "hint", 2);
__decorateClass([
  Prop({
    type: String,
    default: UploadStatus.NORMAL
  })
], FileUploadComponent.prototype, "status", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], FileUploadComponent.prototype, "disabled", 2);
__decorateClass([
  Prop({
    type: Array,
    default: () => []
  })
], FileUploadComponent.prototype, "previousFiles", 2);
__decorateClass([
  Emit("selected")
], FileUploadComponent.prototype, "addFile", 1);
__decorateClass([
  Emit("error")
], FileUploadComponent.prototype, "uploadError", 1);
FileUploadComponent = __decorateClass([
  Component({
    name: "ui-file-upload",
    filters: {
      formatDate
    }
  })
], FileUploadComponent);

export default FileUploadComponent;
export { UploadStatus };
